/* CatSketch storefront — carries cat name + uploaded photo from the immersive
   site, types out a "WELCOME — {NAME}'S GALLERY" greeting near the page title,
   shows a "Your cat uploads" picker on the cart page, puts an attention badge on
   the cart icon, and attaches the chosen photo to any product added to cart.
   Additive only. 2026-06-13 r3 (session-scoped: only after immersive hand-off; legacy localStorage purged). */
(function () {
  // SESSION-scoped (was localStorage). Personalization only lives for the browsing
  // session handed off from the immersive site (params), and is gone on later cold
  // direct visits to catsketch.com — it no longer haunts the browser permanently.
  function lget(k){ try { return sessionStorage.getItem(k); } catch(e){ return null; } }
  function lset(k,v){ try { sessionStorage.setItem(k,v); } catch(e){} }
  // One-time purge of OLD permanent data so stuck name + stale upload thumbnails clear.
  try { ["cs_name","cs_uploads","cs_active_photo"].forEach(function(k){ localStorage.removeItem(k); }); } catch(e){}

  var p = new URLSearchParams(location.search);
  var inName = p.get("cat"), inPhoto = p.get("catphoto");
  if (inName) lset("cs_name", inName);
  if (inPhoto) {
    var ups0 = []; try { ups0 = JSON.parse(lget("cs_uploads") || "[]"); } catch(e){}
    if (ups0.indexOf(inPhoto) === -1) ups0.unshift(inPhoto);
    lset("cs_uploads", JSON.stringify(ups0.slice(0, 12)));
    lset("cs_active_photo", inPhoto);
  }
  if (inName || inPhoto) {
    p.delete("cat"); p.delete("catphoto");
    var q = p.toString();
    try { history.replaceState({}, "", location.pathname + (q ? "?" + q : "") + location.hash); } catch(e){}
  }

  var name = lget("cs_name") || "";
  var active = lget("cs_active_photo") || "";
  var uploads = []; try { uploads = JSON.parse(lget("cs_uploads") || "[]"); } catch(e){}

  function styleOnce(){
    if (document.getElementById("cs-style")) return;
    var s = document.createElement("style"); s.id = "cs-style";
    s.textContent =
      "@keyframes csblink{0%,49%{opacity:1}50%,100%{opacity:0}}" +
      "@keyframes cspulse{0%{transform:scale(1)}50%{transform:scale(1.22)}100%{transform:scale(1)}}" +
      "#cs-greet{font:600 .8rem/1.4 inherit;letter-spacing:.12em;text-transform:uppercase;opacity:.8;margin:0 0 .55rem;min-height:1.2em}" +
      "#cs-greet .cs-caret{margin-left:1px;animation:csblink 1s steps(1) infinite}" +
      ".cs-cart-badge{position:absolute;top:-6px;right:-6px;min-width:18px;height:18px;padding:0 5px;border-radius:999px;background:#111;color:#fff;font:700 11px/18px -apple-system,system-ui,sans-serif;text-align:center;box-shadow:0 0 0 2px #fff;animation:cspulse 1.15s ease-in-out infinite;z-index:6;pointer-events:none}";
    (document.head || document.documentElement).appendChild(s);
  }

  // typewriter greeting near the page title
  function greet() {
    if (!name || document.getElementById("cs-greet")) return;
    var h = document.querySelector(".collection-hero__title, .title-wrapper h1, main .title, main h1, h1");
    if (!h) return;
    styleOnce();
    var g = document.createElement("div"); g.id = "cs-greet";
    var txt = document.createElement("span"); g.appendChild(txt);
    var caret = document.createElement("span"); caret.className = "cs-caret"; caret.textContent = "▌"; g.appendChild(caret);
    h.parentNode.insertBefore(g, h);
    var full = "Welcome — " + name + "’s gallery"; // CSS uppercases it
    var i = 0;
    (function type(){
      if (i <= full.length) { txt.textContent = full.slice(0, i); i++; setTimeout(type, 55); }
      else { setTimeout(function(){ caret.style.display = "none"; }, 1600); }
    })();
  }

  // attention badge on the cart icon
  function cartBadge() {
    var icon = document.getElementById("cart-icon-bubble") || document.querySelector('a[href$="/cart"], a[href*="/cart"]');
    if (!icon || icon.__csBadged) return;
    fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function(r){ return r.json(); }).then(function(c){
      var n = (c && c.item_count) || 0;
      var dawn = icon.querySelector(".cart-count-bubble");
      var show = n > 0 ? n : (active ? 1 : 0);
      if (!show) return;
      if (n > 0 && dawn) return; // Dawn already shows a real count
      icon.__csBadged = true;
      styleOnce();
      if (getComputedStyle(icon).position === "static") icon.style.position = "relative";
      var b = document.createElement("span"); b.className = "cs-cart-badge"; b.textContent = String(show);
      icon.appendChild(b);
    }).catch(function(){});
  }

  function injectProps() {
    if (!active) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.__csCatInjected) return; form.__csCatInjected = true;
      function hid(n, v) { var i = document.createElement("input"); i.type = "hidden"; i.name = n; i.value = v; form.appendChild(i); }
      hid("properties[_preview_image]", active);
      hid("properties[Cat photo]", active);
      if (name) hid("properties[Cat name]", name);
    });
  }
  function refreshInjected() {
    document.querySelectorAll('form[action*="/cart/add"] input[name="properties[_preview_image]"]').forEach(function (i) { i.value = active; });
    document.querySelectorAll('form[action*="/cart/add"] input[name="properties[Cat photo]"]').forEach(function (i) { i.value = active; });
  }

  function onCartPage() {
    return /\/cart(\/|$|\?|#)/.test(location.pathname + location.search) ||
           !!document.querySelector("cart-items, #main-cart-items, .cart__items, .cart__warnings");
  }
  function renderUploads() {
    if (!uploads.length || !onCartPage() || document.getElementById("cs-uploads")) return;
    var wrap = document.createElement("div"); wrap.id = "cs-uploads";
    wrap.style.cssText = "max-width:1100px;margin:8px auto 28px;padding:18px 16px;text-align:center;border:1px solid rgba(0,0,0,.1);border-radius:14px;";
    var h = document.createElement("div"); var headFull = name ? ("Hey " + name + "’s owner — we have your picture here") : "We have your picture here"; h.style.cssText = "font:700 1.1rem/1.35 inherit;letter-spacing:.01em;margin-bottom:6px;min-height:1.3em;";
    var sub = document.createElement("div"); sub.style.cssText = "font-size:.82rem;opacity:.6;margin-bottom:14px;";
    sub.textContent = "Pick the photo, then choose a style — it rides along automatically.";
    var row = document.createElement("div"); row.style.cssText = "display:flex;gap:12px;justify-content:center;flex-wrap:wrap;";
    uploads.forEach(function (u) {
      var b = document.createElement("button"); b.type = "button";
      b.style.cssText = "width:76px;height:76px;border-radius:12px;overflow:hidden;padding:0;cursor:pointer;background:#f2f2f2;border:2px solid " + (u === active ? "#111" : "transparent") + ";";
      var im = document.createElement("img"); im.src = u; im.alt = "Your cat"; im.loading = "lazy";
      im.style.cssText = "width:100%;height:100%;object-fit:cover;display:block;";
      b.appendChild(im);
      b.addEventListener("click", function () {
        active = u; lset("cs_active_photo", u);
        row.querySelectorAll("button").forEach(function (x) { x.style.borderColor = "transparent"; });
        b.style.borderColor = "#111"; refreshInjected();
      });
      row.appendChild(b);
    });
    var cta = document.createElement("a"); cta.href = "/collections/all"; cta.textContent = "Choose a style →";
    cta.style.cssText = "display:inline-block;margin-top:14px;font:700 .8rem/1 inherit;letter-spacing:.1em;text-transform:uppercase;text-decoration:underline;text-underline-offset:4px;";
    wrap.appendChild(h); wrap.appendChild(sub); wrap.appendChild(row); wrap.appendChild(cta);
    var anchor = document.querySelector("#main-cart-items, cart-items, .cart__items, .cart__warnings, main .page-width, main");
    if (anchor) anchor.parentNode.insertBefore(wrap, anchor); else document.body.insertBefore(wrap, document.body.firstChild);
    (function(){ var hi = 0; (function typeH(){ if (hi <= headFull.length){ h.textContent = headFull.slice(0, hi); hi++; setTimeout(typeH, 38); } })(); })();
  }

  function run() { try { greet(); cartBadge(); injectProps(); renderUploads(); } catch(e){} }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
  if (window.MutationObserver) {
    var t = null;
    new MutationObserver(function () { if (t) return; t = setTimeout(function(){ t = null; injectProps(); renderUploads(); }, 300); })
      .observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
